import gsap from 'gsap'

window.openCallback = null
window.closeCallback = null
window.animateTitle = null
document.addEventListener('DOMContentLoaded', () => {
  const calculatorCallback = document.querySelector('.calculator-callback')
  const calculatorPrice = document.querySelector('.calculator-callback__head-block--price')
  const calculatorPriceUpdate = document.querySelector('.calculator-callback__head-block--update')
  const calculatorClose = document.querySelector('.calculator-callback__close')
  const calculatorBack = document.querySelector('.calculator-callback__back')

  if (calculatorPrice && calculatorPriceUpdate && calculatorCallback) {
    let isMobile = window.innerWidth < 1024

    window.addEventListener('resize', () => {
      isMobile = window.innerWidth < 1024
    })

    let active = calculatorPrice

    window.animateTitle = () => {
      if (active === calculatorPrice) {
        gsap.fromTo(calculatorPrice, { y: 0 }, { y: '-100%' })
        gsap.fromTo(calculatorPriceUpdate, { y: '100%' }, { y: '0' })
        active = calculatorPriceUpdate
        return
      }
      gsap.fromTo(calculatorPriceUpdate, { y: 0 }, { y: '-100%' })
      gsap.fromTo(calculatorPrice, { y: '100%' }, { y: '0' })
      active = calculatorPrice
    }

    window.openCallback = () => {
      if (calculatorCallback.classList.contains('calculator-callback--view')) return
      if (isMobile) document.body.classList.add('body--no-scroll')
      calculatorCallback.classList.add('calculator-callback--view')
    }

    window.closeCallback = (e = null) => {
      if (e) e.preventDefault()
      if (isMobile) document.body.classList.remove('body--no-scroll')
      calculatorCallback.classList.remove('calculator-callback--view')
    }

    calculatorClose?.addEventListener('click', window.closeCallback)
    calculatorBack?.addEventListener('click', window.closeCallback)


  }
})
